<template>
  <div>
    <w-radio-list class="form-group" :model="model.type" :values="employerTypes" />

    <person :model="model">
      <div class="row form-group">
        <div class="col-6">
          <w-input :model="model.workplaceName" />
        </div>

        <div class="col-6">
          <w-input :model="model.nip" />
        </div>
      </div>
      <div class="row form-group mt-2">
        <div class="col-6">
          <w-input :model="model.phoneNumber" />
        </div>

        <div v-if="model.bankAccount" class="col-6">
          <w-input :model="model.bankAccount" />
        </div>
      </div>
    </person>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Person from './Person.vue';

// @vuese
// Formularz wnioskodawcy-pracodawcy
export default {
  components: {
    Person,
    ...components
  },
  props: {
    // Model wnioskodawcy-pracodawcy
    model: { type: Object, required: true }
  },
  data() {
    return {
      employerTypes: [
        { value: 1, text: 'Osoba fizyczna' },
        { value: 2, text: 'Osoba prawna' }
      ]
    };
  }
};
</script>
